import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {
  namespaced: true,

  actions: {
    async updateDetails( {getters, commit}, payload ) {
      let user = getters.user;
      console.log(JSON.stringify(payload))
      return new Promise((resolve, reject) => {
        axios.post(`/user/${user.id}/detail`, payload)
          .then(async (res1) => {

            let current_step = 3;
            if (!_.isEmpty(payload.subdomain)) {
              current_step = 4;
            }

            if(payload.hasOwnProperty('isInvited')){
              current_step = 6 
            }

            await axios.patch(`/user/${user.id}`, { onboard_step: current_step }).then(()=>{
              let payload = { 
                onboard_step: current_step,
                ...res1.data.data
              }

              /// the id in this payload is user_details_id not user_id
              payload.id = user.id;

              commit('UPDATE_USER_INFO', payload);
              resolve(payload)
            }).catch((error) => {
              reject(error);
            })
          }).catch((error) => {
            reject(error);
          })
      });
    },

    async updateOnboardStep( {commit}, param ) {
      try {
        await axios.patch(`/user/${param.user_id}`, { onboard_step: param.onboard_step });
        commit('UPDATE_USER_INFO', { onboard_step: param.onboard_step });
      } catch(e) {
        throw(e);
      }
    }
  },

  getters: {
    user: (state) => state,
    organizations: (state) => state.organizations,
    invitations: (state) => state.invitations,
  },

  mutations: {
    UPDATE_USER_INFO (state, payload) {
      // copy property from payload to state
      // skiplist:
      let skiplist = ['details', 'organizations', 'invitations'];

      for (const property of Object.keys(payload)) {
        if (skiplist.indexOf(property) > -1 && _.isEmpty(payload[property])) {
          continue;
        }

        state[property] = payload[property]
      }
    },

    UPDATE_SELECTED_ORGANIZATION (state, param) {
      state.current_organization = param.organization_id;
      state.current_subdomain = param.subdomain;
      state.current_role = param.role_name;
    },
  },

  state: {
  },
}
